module.exports = __webpack_public_path__ + "img/icon-student-2.2b90897.png";